import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const ifNotAdminRedirectTo =
  (routeName: string): NavigationGuard =>
  (to, from, next) => {
    if (useAuthStore().isUserAdmin) {
      return next();
    } else {
      next({ name: routeName });
    }
  };
